import gql from 'graphql-tag';

export const typeDefs = gql`
  type Identities {
    dateCreated: Int
    issuer: String
    primary: Boolean
    providerName: String
    providerType: String
    userId: String
  }

  type Profile {
    merchantId: String
    merchantName: String
    email: String
    emailVerified: Boolean
    familyName: String
    givenName: String
    userType: String
    userRole: String
    sub: String
    identities: [Identities]
  }

  type Mutation {
    setProfile(profile: Profile!): Profile
    createSplitioClient(key: String!): String
  }

  type Query {
    userProfile: Profile!
    splitioEvent: String!
  }
`;
